import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20photography%20with%20overlapping%20translucent%20fabric%20textures%20in%20earthy%20olive%20sage%20and%20warm%20sand%20tones%2C%20diagonal%20morning%20light%20casting%20soft%20geometric%20shadows%2C%20ethereal%20editorial%20composition%20with%20generous%20negative%20space%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20dreamy%20atmospheric%20quality%20with%20subtle%20grain%20texture&width=1600&height=900&seq=hero-bg-main-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 flex-1 flex items-center pt-20">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-span-7 flex flex-col justify-center">
              <p className="text-background-50/70 text-sm md:text-base font-medium tracking-wider mb-4 uppercase">
                {t('hero.tagline1')}
              </p>
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-[1.05] mb-4">
                {t('hero.tagline2')}
              </h1>
              <p className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-background-50/90 leading-tight">
                {t('hero.tagline3')}
              </p>
            </div>

            <div className="lg:col-span-5 flex flex-col justify-end pb-8">
              <p className="text-background-50/80 text-base md:text-lg leading-relaxed mb-6 max-w-md">
                {t('hero.subtitle')}
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full border-2 border-background-50 text-background-50 text-sm font-semibold hover:bg-background-50 hover:text-foreground-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  {t('cta.buyItNow')}
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full h-[40vh] md:h-[45vh] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Curated%20fashion%20collection%20floating%20arrangement%20with%20sneakers%20denim%20jacket%20sunglasses%20and%20leather%20accessories%20suspended%20in%20mid%20air%20against%20bright%20white%20studio%20background%2C%20dramatic%20top%20lighting%20creating%20crisp%20defined%20shadows%2C%20editorial%20fashion%20photography%20with%20bold%20graphic%20composition%2C%20high%20contrast%20clean%20modern%20aesthetic&width=1600&height=700&seq=hero-bottom-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet kategorie produktów"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}